
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/protection-des-donnees",
      function () {
        return require("private-next-pages/protection-des-donnees.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/protection-des-donnees"])
      });
    }
  